"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PAGE_LIMIT = exports.DEFAULT_PAGE_LIMIT = void 0;
exports.applySortedFilter = applySortedFilter;
exports.paginate = paginate;
const in_memory_executor_1 = require("./in-memory-executor");
exports.DEFAULT_PAGE_LIMIT = 50;
exports.MAX_PAGE_LIMIT = 500;
function applySortedFilter(entries, filters, sort, logicOperator, schema, accessors) {
    const filtered = (0, in_memory_executor_1.applyColumnFilters)(entries, filters ?? [], schema, accessors, logicOperator);
    const sorted = sort && sort.length > 0 ? (0, in_memory_executor_1.applySort)(filtered, sort, schema, accessors) : filtered;
    return sorted;
}
function paginate(items, cursor, limit, getKey) {
    const take = Math.min(Math.max(limit ?? exports.DEFAULT_PAGE_LIMIT, 1), exports.MAX_PAGE_LIMIT);
    let start = 0;
    if (cursor !== undefined && cursor !== '') {
        const idx = items.findIndex((it) => getKey(it) === cursor);
        if (idx < 0) {
            return { items: [], endCursor: null, hasNextPage: false, totalCount: items.length };
        }
        start = idx + 1;
    }
    const slice = items.slice(start, start + take + 1);
    const hasNextPage = slice.length > take;
    const page = hasNextPage ? slice.slice(0, take) : slice;
    const endCursor = page.length > 0 ? getKey(page[page.length - 1]) : null;
    return {
        items: page,
        endCursor,
        hasNextPage,
        totalCount: items.length,
    };
}
//# sourceMappingURL=in-memory-pagination.js.map